import { PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../../theme';
import { ChronosphereColorPalette, red } from '../colors';
import { buildPaletteForMode, type PaletteTokenMetadata, type Token } from '../panw-palette/token-metadata';

const errorColorTokens = [
  { propertyPath: 'main', tokenName: '--semantic-data-informative-negative' },
  { propertyPath: 'highContrast', tokenName: '--data-informative-negative-high-contrast' },
  { propertyPath: 'lowContrast', tokenName: '--data-informative-negative-low-contrast' },
] satisfies Token[];

export const errorColorMetadata: PaletteTokenMetadata = {
  componentName: 'status-error',
  tokens: errorColorTokens,
};

export const errorColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return buildPaletteForMode<ChronosphereColorPalette>(errorColorTokens, mode);
  }
  return mode === 'light'
    ? {
        main: red[600],
        highContrast: red[700],
        lowContrast: red[100],
      }
    : {
        main: red[500],
        highContrast: red[100],
        lowContrast: red[800],
      };
};
